import config from "./config";
import axios from "axios";

const base = `${config.api}/admin`;
const token = config.token;

export default {
    get: (route = "") => {
        return new Promise((resolve) => {
            axios.get(`${base}${route}`, {
                headers: {
                    "authorization": token
                }
            })
                .then(r => {
                    resolve(r.data);
                })
                .catch(err => {
                    config.handleError(err);
                    resolve(null);
                });
        })
    },
    delete: (route = "") => {
        return new Promise((resolve) => {
            axios.delete(`${base}${route}`, {
                headers: {
                    "authorization": token
                }
            })
                .then(r => {
                    resolve(r.data);
                })
                .catch(err => {
                    config.handleError(err);
                    resolve(null);
                });
        })
    },
    post: (route = "", params = {}) => {
        return new Promise((resolve) => {
            axios.post(`${base}${route}`, JSON.stringify(params), {
                headers: {
                    "authorization": token,
                    "content-type": "application/json"
                }
            })
                .then(r => {
                    resolve(r.data);
                })
                .catch(err => {
                    config.handleError(err);
                    resolve(null);
                });
        })
    },
    put: (route = "", params = {}) => {
        return new Promise((resolve) => {
            axios.put(`${base}${route}`, JSON.stringify(params), {
                headers: {
                    "authorization": token,
                    "content-type": "application/json"
                }
            })
                .then(r => {
                    resolve(r.data);
                })
                .catch(err => {
                    config.handleError(err);
                    resolve(null);
                });
        })
    }
}